import React, { useState } from 'react';
import Editor from './Editor';

const FormNews = () => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [shortcontent, setShortcontent] = useState('');
    const [author, setAuthor] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Simple validation
        if (!title || !content || !shortcontent || !author) {
            setMessage('Please fill out all fields');
            return;
        }

        // Simulate a POST request to your API (replace with actual API call)
        const newBlog = {
            title,
            content,
            shortcontent,
            author,
            date: new Date().toISOString(),
        };

        try {
            // Make API request (example using fetch)
            const response = await fetch('https://your-api-url.com/blogs', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newBlog),
            });

            if (response.ok) {
                setMessage('News post created successfully!');
                setTitle('');
                setContent('');
                setAuthor('');
            } else {
                setMessage('Error creating blog post');
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <h2 className="text-center mb-4">Add News</h2>

                    {message && <p className="text-center text-danger">{message}</p>}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label htmlFor="title">Title</label>
                            <input
                                type="text"
                                id="title"
                                className="form-control"
                                placeholder="Enter news title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                                maxLength={160}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label htmlFor="shortcontent">Short Content</label>
                            <textarea
                                id="shortcontent"
                                className="form-control"
                                placeholder="Enter short content"
                                rows="2"
                                value={shortcontent}
                                onChange={(e) => setShortcontent(e.target.value)}
                                required
                                style={{ resize: 'none' }}
                                maxLength={160}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label htmlFor="content">Content</label>
                            <Editor />
                        </div>
                        {/* <div className="form-group mb-3">
                            <label htmlFor="content">Content</label>
                            <textarea
                                id="content"
                                className="form-control"
                                placeholder="Enter content"
                                rows="5"
                                value={content}
                                onChange={(e) => setContent(e.target.value)}
                                required
                                style={{ resize: 'none' }}
                            />
                        </div> */}
                        <div className="form-group mb-3">
                            <label htmlFor="author">Author</label>
                            <input
                                type="text"
                                id="author"
                                className="form-control"
                                placeholder="Enter author name"
                                value={author}
                                onChange={(e) => setAuthor(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="btn btn-primary w-100">
                            Submit News
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default FormNews;
